import styled from "styled-components";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export default function AppTextEditor({
  height = 250,
  className,
  toolbar = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
      [{ direction: "rtl" }],
    ],
  },
  disabled = false,
  value,
  error,
  onChange,
}) {
  const handleOnChange = (v, source) => {
    if (source === "api") return;

    if (
      v === "" ||
      v === "<p><br></p>" ||
      v === undefined ||
      v === null ||
      !v
    ) {
      onChange("");
    } else if (v) {
      onChange(v);
    } else {
      onChange("");
    }
  };
  return (
    <EditorWrapper height={height} error={error}>
      <ReactQuill
        theme="snow"
        className={className}
        modules={toolbar}
        value={value}
        onChange={(e, delta, source) => handleOnChange(e, source)}
        readOnly={disabled}
      />
    </EditorWrapper>
  );
}

const EditorWrapper = styled.div`
  flex-grow: 1;
  .tox-statusbar__branding {
    display: none;
  }
  .ql-editor {
    height: ${(props) => props.height}px;
    font-size: 14px;
    font-family:
      -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
      Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
      "Segoe UI Symbol";
    color: black;
    border: 1px solid ${(props) => (props.error ? "red" : "transparent")};
  }
`;
